import { render, staticRenderFns } from "./MyDutyDetailWidget.vue?vue&type=template&id=da59ce48&scoped=true&"
import script from "./MyDutyDetailWidget.vue?vue&type=script&lang=js&"
export * from "./MyDutyDetailWidget.vue?vue&type=script&lang=js&"
import style0 from "./MyDutyDetailWidget.vue?vue&type=style&index=0&id=da59ce48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da59ce48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCheckbox,VChip,VSpacer,VToolbarTitle})
